import { ErrorInfo, errCodeHandle } from '../tools/error'
import detectEthereumProvider from '@metamask/detect-provider'
import { Wallet } from './wallet'

/**
 * 钱包
 * @extends Wallet
 */
export class MetaMask extends Wallet {
  constructor() {
    super()
  }

  /**
   * 连接钱包
   * @param {function} callback - 账号改变事件回调
   * @return {Promise<unknown>} 连接成功与失败
   */
  async connect(callback) {
    this._callback = callback
    // 测试是否有小狐狸
    const ethereum = await detectEthereumProvider()
    if (ethereum && ethereum.isMetaMask) {
      console.log('isMetaMask')
      this._connector = ethereum
    } else {
      errCodeHandle.go(210001)
      throw ErrorInfo(210001)
    }
    // 连接小狐狸
    let accounts = null
    try {
      accounts = await this._connector.request({
        method: 'eth_requestAccounts'
      })
    } catch (err) {
      if (err.code !== undefined && err.message !== undefined) {
        throw {
          code: err.code,
          msg: err.message
        }
      } else {
        errCodeHandle.go(210002)
        throw ErrorInfo(210002)
      }
    }
    this.account = accounts[0]
    // 获取chain id
    this.chainId = parseInt(this._connector.chainId, 16)
    this._addListener()
    this._getEthers()
  }

  /**
   * 断开连接 重置钱包
   */
  async disconnect() {
    this._connector.removeListener('accountsChanged', this._cbAccountsChanged)
    this._connector.removeListener('chainChanged', this._cbChainChanged)
    // connect disconnect 无法触发 只会触发 accountsChanged 事件
    // this._connector.removeListener('connect', this._cbConnect)
    // this._connector.removeListener('disconnect', this._cbDisconnect)
    this._initWallet()
  }

  /**
   * 获取chain Id
   * @return {Promise<number>}
   */
  async getChainId() {
    if (this._connector === null) {
      // 测试是否有小狐狸
      const ethereum = await detectEthereumProvider()
      if (ethereum && ethereum.isMetaMask) {
        return parseInt(ethereum.chainId, 16)
      } else {
        errCodeHandle.go(210001)
        throw ErrorInfo(210001)
      }
    } else {
      // 获取chain id
      this.chainId = parseInt(this._connector.chainId, 16)
      return this.chainId
    }
  }

  // 绑定监听事件
  _addListener() {
    this._cbAccountsChanged = accounts => {
      if (this.account !== accounts[0]) {
        this.account = accounts[0]
        this._handleCallback(this._callback, 'accountsChanged', this.account)
      }
    }
    this._connector.on('accountsChanged', this._cbAccountsChanged)

    this._cbChainChanged = chainId => {
      const newChainId = parseInt(chainId, 16)
      if (this.chainId !== newChainId) {
        this.chainId = newChainId
        this._handleCallback(this._callback, 'chainChanged', this.chainId)
      }
    }
    this._connector.on('chainChanged', this._cbChainChanged)

    // connect disconnect 无法触发 只会触发 accountsChanged 事件
    // this._cbConnect = () => {
    //   console.log('connect')
    //   this._handleCallback(this._callback, 'connect')
    // }
    // this._connector.on('connect', this._cbConnect)
    //
    // this._cbDisconnect = (code, reason) => {
    //   console.log('disconnect', code, reason)
    //   this._handleCallback(this._callback, 'disconnect')
    // }
    // this._connector.on('disconnect', this._cbDisconnect)
  }
}
